import { RemoteControlClickType } from '../../enums/remote-control-click-type.enum';

export class RemoteClickEvent {
    constructor(
        public clickType: RemoteControlClickType,
        public XMousePos: number,
        public YMousePos: number
    ) { }
}